/*
akhila 10/27/2022 2701251212  record format UX Changes
ashraf 10/30/2022 2701251212 conditional tabs render
*/

import {Card} from '@material-ui/core';
import React, {useContext} from 'react';
import Tabs from './Tabs';
import LandingPage from '../../LandingPage';
import {ThemeContext} from '../../../themes/ThemeProvider';

function RecordFormat() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const [value, setValue] = React.useState(0);
  const classes = reusableInputStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabLabels = ['Record Format'];

  return (
    <>
      <LandingPage title={'Frameworks'} showTabs={true} tabValue={value} handleTabChange={handleChange} allAntTabs={tabLabels}/>
      <div className={`col-md-12 dash-board`}>
        <Card className={`${classes.cardStyling} mb-0`} elevation={0}>
          <div>
            <Tabs value={value} setValue={setValue}/>
          </div>
        </Card>
      </div>
    </>
  );
}

export default RecordFormat;
